































































import { Vue, Component, Mixins, Prop } from "vue-property-decorator";
import MyList from "@/mixins/list";

import moment from "moment";
import filesaver from "file-saver";

import SelectStadium from "@/components/selectstadium.vue";

@Component({
  components: {
    SelectStadium
  }
})
export default class extends Mixins(MyList) {
  @Prop() userId!: number;

  dispatchType = "finance/getReconciliactionDetail";

  columns: any[] = [
    { title: "编号", dataIndex: "id" },

    {
      title: "时间",
      dataIndex: "created_time"
    },
    {
      title: "场馆",
      dataIndex: "stadium_name"
    },
    {
      title: "类型",
      dataIndex: "type_name"
    },
    {
      title: "标题",
      dataIndex: "title"
    },
    {
      title: "金额",
      scopedSlots: { customRender: "fee" }
    },
    {
      title: "金额",
      scopedSlots: { customRender: "p_fee" }
    },
    {
      title: "交易单号",
      dataIndex: "trade_no"
    },
    {
      title: "支付/退款方式",
      dataIndex: "channel_name"
    },
    {
      title: "会员卡",
      scopedSlots: { customRender: "card_name" }
    },
    {
      title: "备注",
      dataIndex: "remark"
    }
  ];

  async exportExcel() {
    this.$confirm({
      title: "确认信息",
      content: "确定要导出数据吗",
      onOk: async () => {
        const res = await this.$store.dispatch("finance/exportTradeLogs", {
          ...this.reloadQueryData
        });
        if (res && res.data) {
          const blob = new Blob([res.data], {
            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
          });

          filesaver.saveAs(blob, `账单${moment().format("YYYY-MM-DD HH:mm:ss")}.xlsx`);
        }
      }
    });
  }

  mounted() {
    // console.log("mounted1");
    this.loadData(
      {
        user_id: this.userId
      },
      false
    );
  }
}
